export const JOB_SERIES_ROUTES = {
    LIST: "/{service_company_slug}/job-series/",
    COUNT: "/{service_company_slug}/api/job-series/count/",
    LIGHTWEIGHT_LIST: "/{service_company_slug}/api/job-series/lightweight/",
    DETAILS: "/{service_company_slug}/jobs/",
}
